import { fetchApi } from 'Utils/utils';

let fetchHomepageContent = function() {
  return fetchApi.get('/api/v1/home/');
};

export { fetchHomepageContent };
